// Site-wide head defaults, kept apart from the page builders in meta.js so
// the app shell (headManager.js) carries only these few lines.

export const SITE_NAME = 'Rentra'
export const DEFAULT_DESCRIPTION =
  'Rentra keeps the record of a San Diego rental: the search, the household lease, the rent and the deposit statement.'
export const DEFAULT_IMAGE = 'https://myrentra.com/logo-mark.png'

/** 'Browse rentals' -> 'Browse rentals | Rentra'; empty -> 'Rentra'. */
export function formatTitle(title) {
  const t = String(title || '').trim()
  if (!t) return SITE_NAME
  if (
    t === SITE_NAME ||
    t.endsWith(`| ${SITE_NAME}`) ||
    t.startsWith(`${SITE_NAME} |`)
  )
    return t
  return `${t} | ${SITE_NAME}`
}
